"use client";

const items = [
  "✨ FREE Shipping on Orders Over $35",
  "📚 30+ Magical Book Titles",
  "🌍 Ships to 30+ Countries",
  "⭐ 4.9/5 Star Rating",
  "🎨 Educator Approved",
  "🦄 New 2026 Collection Available",
  "💜 Trusted by 50,000+ Families",
  "🌈 Bilingual Editions Available",
];

export default function MarqueeSection() {
  const doubled = [...items, ...items];

  return (
    <div className="bg-plum py-3.5 overflow-hidden" aria-hidden="true">
      <div className="marquee-wrap">
        <div className="marquee-track">
          {doubled?.map((item, i) => (
            <span key={i} className="text-white/80 text-xs font-bold tracking-wider whitespace-nowrap px-6 border-r border-white/20 last:border-none">
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}